import * as CreateProjectTeamMemberTypes from 'src/actions/project/team-member/create/Types';
import { CreateProjectTeamMemberAction } from 'src/actions/project/team-member/create/CreateProjectTeamMember.actions';

export interface CreateProjectTeamMemberState {
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: CreateProjectTeamMemberState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function CreateProjectTeamMemberReducer(state: CreateProjectTeamMemberState = initialState,
                                               action: CreateProjectTeamMemberAction): CreateProjectTeamMemberState {
  switch (action.type) {
    case CreateProjectTeamMemberTypes.CREATE_PROJECT_TEAM_MEMBER_ATTEMPT:
      return {...state, loading: true, error: false};
    case CreateProjectTeamMemberTypes.CREATE_PROJECT_TEAM_MEMBER_SUCCESS:
      return {...state, loading: false, error: false};
    case CreateProjectTeamMemberTypes.CREATE_PROJECT_TEAM_MEMBER_FAILURE:
      return {...state, loading: false, error: true, errorMessage: action.payload};
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/project/team-members/CreateProjectTeamMemberReducer.ts